module.exports = __webpack_public_path__ + "static/img/zhuangshi04.7895ccb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/zhuangshi04.png
// module id = BKKv
// module chunks = 60